import React, { useMemo } from 'react';
import { OrderedListToNumberedList } from './generic/OrderedListToNumberedList';
import { ParseListsFromTextFile } from 'utils/file-parsers';
import { useGetYearlyListRaw } from 'utils/file-reader';
import { firstYearTracked } from 'utils/constants';
import { useParams } from 'react-router';
import { Typography, Checkbox, FormControlLabel } from '@mui/material';

interface Iprops {
    selectedYear?: number,
}

export const YearlyList = (props: Iprops) => {
    const { year = '2024' } = useParams();
    const [filterReplays, setFilterReplays] = React.useState<boolean>(false);
    const [filterReleasedThisYear, setFilterReleasedThisYear] = React.useState<boolean>(false);

    const handleFilterReplayChange = (event: any) => {
        setFilterReplays(event.target.checked);
    };

    const handleFilterReleasedThisYearChange = (event: any) => {
        setFilterReleasedThisYear(event.target.checked);
    };

    const selectedYear = parseInt(year);
    const rawYearlyLists = useGetYearlyListRaw();

    const parsedYearlyLists = useMemo(() => {
        return ParseListsFromTextFile(rawYearlyLists);
      }, [rawYearlyLists]);

    const selectedYearList = useMemo(() => {
        return parsedYearlyLists[selectedYear - firstYearTracked]
    }, [selectedYear, parsedYearlyLists]);

    const note = useMemo(() => {
        let element = null;
        if (selectedYear === 2017) {
            element = <Typography variant="caption">Note: I only have a historical record of top 10 games that released that year for 2017.</ Typography>
        } else if (selectedYear === 2018) {
            element = <Typography variant="caption">Note: 2018's list is partially compiled from memory, and was not created during 2018.</ Typography>
        }

        return element ;
    }, [selectedYear]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body2">
                This is a list of games I played in the given year, ordered from best to worst.
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1.5em', margin: '0.5em 0' }}>
                <FormControlLabel control={<Checkbox checked={filterReplays} onChange={handleFilterReplayChange} />} label="Filter Replays" />
                <FormControlLabel control={<Checkbox checked={filterReleasedThisYear} onChange={handleFilterReleasedThisYearChange} />} label="Released This Year Only" />
            </div>
            <OrderedListToNumberedList data={selectedYearList} filterReplays={filterReplays} filterReleasedThisYear={filterReleasedThisYear} note={note} />
        </div>
    )
}